export const nav = [
    {
        title: 'Home',
        url: '/'
    },
    {
        title: 'About',
        url: '/about'
    },
    // {
    //     title: 'Careers',
    //     url: '/careers'
    // },
    // {
    //     title: 'Contact',
    //     url: '/contact'
    // },
    // {
    //     title: 'FAQ',
    //     url: '/faq'
    // },
    {
        title: 'Apply for Business Loans',
        url: '/apply'
    },
    {
        title: 'Apply for Business Credit Cards',
        url: '/creditcard'
    },
    {
        title: 'Apply For Personal Loan',
        url: '/personaloan'
    },
    {
        title: 'Credit Repair',
        url: '/creditrepair'
    },
]